import type { AiToolCall } from "../../services/chatService";

// ===========================================================================
// Chat — agent actions on an AI message (issue #522).
//
// Shows, under an AI bubble, what the AI did for that reply: checked the
// calendar, booked a demo, saved data on the lead — or tried and was refused.
// Labels come ready from the backend (chatAgent/actions.js).
// ===========================================================================

const TOOL_ICONS: Record<string, string> = {
  consultar_disponibilidad: "ri-calendar-line",
  agendar_demo: "ri-calendar-check-line",
  actualizar_lead: "ri-user-settings-line",
};

export function AiToolCallChips({ calls }: { calls?: AiToolCall[] | null }) {
  const list = Array.isArray(calls) ? calls.filter((c) => c && c.label) : [];
  if (list.length === 0) return null;
  return (
    <div className="mt-1 flex flex-wrap gap-1" aria-label="Acciones de la IA">
      {list.map((c, i) => (
        <span
          key={`${c.tool}-${c.at ?? i}-${i}`}
          className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-medium ${
            c.ok
              ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"
              : "bg-gray-500/15 text-gray-600 dark:text-gray-300"
          }`}
          title={c.ok ? "Acción realizada por la IA" : `Acción rechazada${c.error ? ` (${c.error})` : ""}`}
        >
          <i className={c.ok ? TOOL_ICONS[c.tool] || "ri-flashlight-line" : "ri-forbid-line"} />
          {c.label}
        </span>
      ))}
    </div>
  );
}
